// Global
import React from 'react';
import clsx from 'clsx';
import styles from './ProductHeroDecor.module.scss';
import { useIsMobile } from 'lib/hooks/useIsMobile';

export const ProductHeroDecor = () => {
  const isMobile = useIsMobile();

  return (
    <div className={clsx(styles.decorWrapper, styles.decorMarginAdjustment)}>
      <svg
        className={clsx(styles.decorStylePillsbury, styles.decorColor)}
        xmlns="http://www.w3.org/2000/svg"
        width={isMobile ? '400' : '1400'}
        height={isMobile ? '34' : '85'}
        viewBox={isMobile ? '0 0 400 34' : '0 0 1400 85'}
        fill="none"
      >
        {isMobile ? (
          <path
            d="M0 34H400V20C379 21 366.028 6.33282 322 3.5C277.972 0.667183 258.194 24.3385 188.024 24.3385C117.854 24.3385 79 -6 0 19.5205V34Z"
            fill="currentColor"
          />
        ) : (
          <path
            d="M0 85H1400V46C1400 46 1295.1 23 1141 16C986.903 9 900.231 50 654.635 50C409.04 50 274.5 4 0 25.2205V85Z"
            fill="currentColor"
          />
        )}
      </svg>
    </div>
  );
};
